<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Deputy Director's Message</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a routerLink="javascript:void(0);">Deputy Director's Message</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="chairman-msg ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-9">
        <p>GHRCACS, a leading educational institution, is committed to providing a stimulating and inclusive environment
          that nurtures the intellectual and personal development of every individual. We strongly believe in the power
          of education to shape lives and communities, and we strive to empower our students with the skills and
          knowledge they need to thrive in today's ever-evolving world. We have dedicated faculty members who are
          experts in their respective fields and committed to excellence in teaching and mentoring students. We offer a
          wide range of academic programs across a variety of disciplines at GHRCACS, so that every student can pursue
          their passion while receiving a comprehensive education.</p>
        <p>We will strive to create a learning environment where our students are able to acquire knowledge and advanced
          skills in their specialized fields enabling them to fulfill their aspirations.</p>
        <p>With Warm Regards!</p>
      </div>
      <div class="col-12 col-lg-3 ">
        <img src="{{baseUrl}}/faculty/Dy.Director-2.webp" alt="Dr. H. R. Kulkarni | GHRCACS, PUNE" class="img-fluid">
        <div class="box">
          <h4>Dr. Praveen Jangade</h4>
          <p>Deputy Director, GHRCACS</p>
        </div>
      </div>

    </div>
    <!-- <div class="row">
            <div class="col-12 col-lg-9">
                <blockquote class="blockquote-div">
                    <p>Education is not the learning of facts, but the training of the mind to think
                    </p>
                    <h6>- Albert Einstein</h6>
                </blockquote>
                <p>Our team of G H Raisoni Senior College (GHRCACS) believes in the absolute development of all students involving their mind, body and soul in a sustained manner. We provide environment in our college which enables them to realize their self-esteem and potential in every sphere of life. Here at G H Raisoni senior college they gain awareness and learn to assert their rights by equipping and strengthening themselves. We motivate our students to take a small positive step in the direction of self development and become successful human being. We assure you that students of GHRCACS will be proud of their almamater throughout their life.</p>
                <p>The task of an excellent teacher is to stimulate apparently ordinary people to unusual efforts. The tough problem is not in identifying winners: it’s making winners out of ordinary people. At GHRCACS all are groomed to be winners.</p>
                <p>Everyone tries to accomplish something big, but life is made up of little things. Little things done meticulously lead to perfection and you know perfection in anything is a big achievement which acts as a catalyst for achieving success. At GHRCACS we care for small things.</p>
                <blockquote class="blockquote-div mt-3">
                    <p>Think Education Think Raisoni
                    </p>
                </blockquote>
            </div>
            <div class="col-12 col-lg-3">
                <img src="{{baseUrl}}/faculty/suresh-dharane.webp" alt="suresh-dharane" class="img-fluid">
                <div class="box">
                    <h4>Dr. Suresh Dharane </h4>
                    <p>PhD., MPhil, MA, M.Com, <br>MPM, PGDAEM, GDCA</p>
                    <p>Principal</p>
                </div>
            </div>
        </div> -->
  </div>
</section>
